import React from 'react';
import { translations } from '../translations';

function Footer({ language, onOpenPrivacy, onOpenCookies, onOpenTerms }) {
  const t = translations[language];

  return (
    <footer>
      <p className="footer-logo">
        Chess<span>Mindset</span>.academy
      </p>
      <p className="footer-text">{t.footerText}</p>
      <div className="footer-links">
        <button type="button" className="footer-link-btn" onClick={onOpenPrivacy}>
          {t.footerPrivacy}
        </button>
        <button type="button" className="footer-link-btn" onClick={onOpenCookies}>
          {t.footerCookies}
        </button>
        <button type="button" className="footer-link-btn" onClick={onOpenTerms}>
          {t.footerTerms}
        </button>
        <a
          className="footer-link-btn footer-link-anchor"
          href="/refund-policy/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t.footerRefund}
        </a>
        <a
          className="footer-link-btn footer-link-anchor"
          href="/pricing/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t.footerPricing}
        </a>
        <a className="footer-link-btn footer-link-anchor" href="mailto:contact@chessmindset.academy">
          contact@chessmindset.academy
        </a>
      </div>
      <p className="footer-copy">{t.footerCopy}</p>
    </footer>
  );
}

export default Footer;
